
  /*  import Single from '@/components/Blocks/Block/Single.vue';*/
  /*  import homeUtils from "@/Utilities/homeUtils";*/
   /* import {BlockContent} from "@/models/Blocks/Itens/block-content";
    import {TemplateItemType} from "@/models/Blocks/Itens/Types/template-item-type";*/
    export default {
        name: 'CategoryPage',
        components: {
            /*Single,*/
            BlocksBlackRabbit: () => import('@/components/Blocks/Desktop.vue'),
            BlocksBlackRabbitMobile: () => import('@/components/Blocks/Mobile.vue'),
        },
        props: {
            bannerProps: {
                type: Object,
                default: null
            },
            blockProps: null,
            isDesktop: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {

            }
        },
        computed: {
           /* bannerBlock() {
                if(!this.bannerProps) {
                    return null;
                }

                const title = {text: this.bannerProps.categoryName ? this.bannerProps.categoryName : 'fdgfdgfsg', color: '#fff'};
                const subtitle = {text: this.bannerProps.categoryText ? this.bannerProps.categoryText : 'sgsdgsdgsfgsfgsdgdgsdg', color: '#333'};
                let struct = new BlockContent(title, null);
                struct.cssClass = 'prz-blk-content-category-banner';
                struct.templateType = TemplateItemType.horizontal;
                struct.backgroundColor = this.bannerProps.categoryColor ? this.bannerProps.categoryColor : '#ababab';
                struct.subtitle = subtitle;

                return struct;
            }*/
        },
        watch: {},
        beforeCreate() {
        },
        mounted() {
           /* console.log('bannerProps:', this.bannerProps);
            console.log('blockProps:', this.blockProps);*/
        },
        methods: {

        }
    }
